import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	placeholderTitle: {
		id: 'custom-sites-extensions.carousel.placeholder.title',
		defaultMessage: 'Give your frame a title',
		description:
			'Initial placeholder title of carousel frame to be displayed in the UI of the editor and view page.',
	},
	placeholderDescription: {
		id: 'custom-sites-extensions.carousel.placeholder.description',
		defaultMessage: 'Customize this frame to create a rotating carousel.',
		description:
			'Initial placeholder description of carousel frame to be displayed in the UI of the editor and view page.',
	},
});
